import { call, takeEvery } from 'typed-redux-saga'
import { dadataApi, DadataNS, dadataSlice, errorHandler } from 'Modules'

function* getAddress(action: DadataNS.GetAddress) {
	try {
		const { params, typeRequest, callback } = action.payload
		const res = yield* call(dadataApi.getAddress, params, typeRequest)
		callback?.(res)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getShortNameSaga(action: DadataNS.GetShortName) {
	try {
		const { params, callback } = action.payload
		const res = yield* call(dadataApi.getShortName, params)
		callback?.(res[0])
	} catch (error) {
		const { errorCallback } = action.payload
		errorCallback?.()
	}
}
export const dadataSaga = function* saga() {
	yield* takeEvery(dadataSlice.actions.getAddress, getAddress)
	yield* takeEvery(dadataSlice.actions.getShortName, getShortNameSaga)
}
